import type { ListTableActionsProps } from "./list-table-actions.type";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";

import ExportButton from "@/components/Export/ExportButton";
import { useListContext } from "@/modules/list";
import {
  ListParamsPreviewButton,
  ListParamsPreviewPanel,
} from "@/modules/list-params-preview";
import ListResetActions from "@/modules/list-reset-actions";

const ListTableActions = ({
  onAddButton,
  addButtonText,
  extraActions,
  showExportButton,
  batchButtons,
}: ListTableActionsProps) => {
  const { t } = useTranslation();
  const { endpoint, fetchParams, loading } = useListContext();

  return (
    <div className="list-table-actions">
      <Flex gap="middle">
        {onAddButton && (
          <Button
            icon={<PlusOutlined />}
            onClick={onAddButton}
            disabled={loading}
          >
            {addButtonText ?? t("global:add")}
          </Button>
        )}
        {extraActions}
        {showExportButton && (
          <ExportButton
            model={endpoint}
            params={fetchParams}
            disabled={loading}
          />
        )}
        {batchButtons}
        <div className="list-table-actions-pusher-divider" />
        <Flex gap="small">
          <ListParamsPreviewButton
            type="text"
            className="list-table-actions-preview-button"
          />
          <ListResetActions />
        </Flex>
      </Flex>
      <ListParamsPreviewPanel />
    </div>
  );
};

export default ListTableActions;
